import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../i18n";

export default function AboutManifesto({ content }) {
  const { t, lang } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const about = lang === "en" ? content.about_en : content.about_es;

  return (
    <section id="about" ref={ref} className="relative z-10 bg-[#0a0a0a] py-24 sm:py-32 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <div className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary-red mb-4">/ {t.about.kicker}</div>
          <h2 className="font-display uppercase text-4xl sm:text-6xl text-white leading-[0.95]">{t.about.title}</h2>
          <p className="mt-6 font-body text-lg text-neutral-400 max-w-lg">{about}</p>

          <div className="mt-12 space-y-px">
            {t.about.chapters.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className="flex gap-5 border-t border-white/10 py-6 group"
                data-testid={`chapter-${i}`}
              >
                <span className="font-display text-3xl text-primary-red shrink-0">{c.n}</span>
                <div>
                  <h3 className="font-display uppercase text-2xl text-white group-hover:text-primary-red transition-colors">{c.t}</h3>
                  <p className="mt-1 font-body text-neutral-400">{c.d}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="relative h-[420px] lg:h-[600px] overflow-hidden">
          <motion.img
            style={{ y: imgY }}
            src="https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            alt="Diesel engine repair"
            className="absolute inset-0 w-full h-[125%] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
          <div className="absolute bottom-6 left-6 bg-primary-red px-6 py-4">
            <div className="font-display text-5xl text-white leading-none">7</div>
            <div className="font-body font-bold uppercase text-white text-xs tracking-widest">
              {lang === "en" ? "Days a Week" : "Días a la Semana"}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
